import React from "react";
import { styled, Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FakeInputField } from "@rentablo/components";
import { Modal } from "@rentablo/components";

const ModalContent = styled(Box)({
  display: "flex",
  flexDirection: "column",
  maxHeight: "calc(100vh - 232px)",
});

const SectionsContainer = styled(Box)({
  display: "grid",
  gridAutoRows: "1fr",
  minHeight: 0,
  overflow: "auto",
  flexShrink: 1,
});

const ModalFooter = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  padding: theme.spacing(6, 4, 4),
  flexShrink: 0,
}));

interface Props {
  label: string;
  selectedLabel: string;
  open: boolean;
  onToggle: () => void;
  onClose: () => void;
  onConfirm: () => void;
  children: React.ReactNode;
}

export const MobileDropdown = ({
  label,
  selectedLabel,
  open,
  onToggle,
  onClose,
  onConfirm,
  children,
}: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <FakeInputField
        value={selectedLabel}
        arrowDirection={open ? "up" : "down"}
        onClick={onToggle}
        disabled={false}
        readonly
        fullWidth
      />
      <Modal
        isOpen={open}
        onClose={onClose}
        title={label}
        width="100%"
        height="fit-content"
        maxHeight="100%"
        position="bottom"
        contentPadding="0!important"
        outerSx={{
          ".modal-heading-container": {
            padding: "16px 24px 0px",
          },
        }}
        zIndex={3001}
      >
        <ModalContent>
          <SectionsContainer>{children}</SectionsContainer>
          <ModalFooter>
            <Button variant="tertiary" fullWidth onClick={onClose}>
              {t("common.back")}
            </Button>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={onConfirm}
              size="large"
            >
              {t("common.confirm")}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
